var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeLogoinline = function SvgYoutubeLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "YoutubeLogo_inline_svg__a",
    d: "M.001 15.999V.013h22.987v15.986z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "m9.12 10.955 6.21-3.182-6.21-3.205v6.387"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "YoutubeLogo_inline_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#YoutubeLogo_inline_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDED9",
    d: "M14.566 8.164 9.12 4.568l6.21 3.205-.764.391",
    mask: "url(#YoutubeLogo_inline_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD201F",
    d: "M9.12 10.955V4.568l6.21 3.205-6.21 3.182zm13.638-7.493s-.225-1.567-.914-2.256C20.97.3 19.99.296 19.541.243c-3.217-.23-8.042-.23-8.042-.23h-.01s-4.825 0-8.042.23c-.45.053-1.43.057-2.304.963C.454 1.896.23 3.462.23 3.462S0 5.302 0 7.14v1.724c0 1.84.23 3.679.23 3.679s.224 1.566.913 2.256c.875.905 2.024.877 2.535.972 1.84.174 7.816.228 7.816.228s4.83-.007 8.047-.237c.45-.053 1.43-.058 2.303-.963.69-.69.914-2.256.914-2.256s.23-1.84.23-3.679V7.141c0-1.84-.23-3.68-.23-3.68z"
  }))));
};
export default SvgYoutubeLogoinline;